App.factory('SurveySubmissions', restmod => restmod.model('/survey_submissions'))
